module.exports = __webpack_public_path__ + "media/ad_preview/house-newsfeed-7fd29192.jpg";